import { useTranslation } from 'react-i18next';
import { Dropdown, Icon, IconNames } from '@triumph/design-system';
import { useAppContext } from '@/app/components/providers/AppContextProvider';
import {
  DAY_OPTIONS,
  HOUR_OPTIONS,
  TIMEZONE_SELECT_OPTIONS,
} from '../communicationPreferences.utils';
import {
  FieldLabelRow,
  ScheduleGrid,
} from '../CommunicationPreferences.StyledComponents';
import { SectionHeading } from './SectionHeading';

interface DeliveryScheduleProps {
  dayOfWeek: number;
  hourLocal: number;
  timeZone: string;
  onDayChange: (day: number) => void;
  onHourChange: (hour: number) => void;
  onTimeZoneChange: (ianaId: string) => void;
}

export const DeliverySchedule: React.FC<DeliveryScheduleProps> = ({
  dayOfWeek,
  hourLocal,
  timeZone,
  onDayChange,
  onHourChange,
  onTimeZoneChange,
}) => {
  const { t } = useTranslation('communicationPreferences');
  const { theme } = useAppContext();

  const labelIcon = (name: IconNames, id: string) => (
    <Icon name={name} id={id} size="sm" color={theme.colors.greyscale.gray40} />
  );

  return (
    <div data-testid="comm-pref-schedule">
      <SectionHeading
        icon={IconNames.Time_Clock}
        iconId="comm-pref-schedule-icon"
        label={t('schedule.title')}
      />
      <ScheduleGrid>
        <div>
          <FieldLabelRow>
            {labelIcon(IconNames.Interface_Calendar, 'comm-pref-day-icon')}
            {t('schedule.dayOfWeek')}
          </FieldLabelRow>
          <Dropdown
            id="comm-pref-day"
            selectTestId="comm-pref-day-select"
            options={DAY_OPTIONS}
            selectedValue={String(dayOfWeek)}
            onChange={(e) => onDayChange(Number(e.target.value))}
          />
        </div>
        <div>
          <FieldLabelRow>
            {labelIcon(IconNames.Time_Clock, 'comm-pref-time-icon')}
            {t('schedule.timeOfDay')}
          </FieldLabelRow>
          <Dropdown
            id="comm-pref-time"
            selectTestId="comm-pref-time-select"
            options={HOUR_OPTIONS}
            selectedValue={String(hourLocal)}
            onChange={(e) => onHourChange(Number(e.target.value))}
          />
        </div>
        <div>
          <FieldLabelRow>
            {labelIcon(IconNames.Location_MapPin, 'comm-pref-timezone-icon')}
            {t('schedule.timezone')}
          </FieldLabelRow>
          <Dropdown
            id="comm-pref-timezone"
            selectTestId="comm-pref-timezone-select"
            options={TIMEZONE_SELECT_OPTIONS}
            selectedValue={timeZone}
            onChange={(e) => onTimeZoneChange(e.target.value)}
          />
        </div>
      </ScheduleGrid>
    </div>
  );
};
